import { useMemo } from "react";

import HooksModalV2Key from "app/constants/HooksModalV2Key";
import { isWorldwideCountry } from "app/pages/sales-intelligence/sub-modules/account-overview/shared/helpers/countries";
import settingsService from "app/pages/sales-intelligence/sub-modules/advanced-search/services/sw-settings/settingsService";
import type { ICountryObject } from "app/services/CountryService";
import { handleCTAClick, TestCases } from "app/common/utils/handleGainAccessRedirect";
import { EHooksVersions } from "app/services/SwHook";

type HookReturnValue = {
    restrictedCountries: ReadonlyArray<Readonly<ICountryObject>>;
    restrictedCountriesWithoutWW: ReadonlyArray<Readonly<ICountryObject>>;
    restrictedCountryAction(): void;
};

export default function useRestrictedCountries(): HookReturnValue {
    const restrictedCountries = useMemo(() => settingsService.getCurrentComponentRestrictedCountries(), []);

    const restrictedCountriesWithoutWW = useMemo(() => {
        return restrictedCountries.filter(isWorldwideCountry);
    }, [restrictedCountries]);
    const restrictedCountryAction = (): void => {
        handleCTAClick(EHooksVersions.V5, HooksModalV2Key.WebCountry, TestCases.TRIAL_AFTER_TRIAL);
    };

    return {
        restrictedCountries,
        restrictedCountriesWithoutWW,
        restrictedCountryAction,
    };
}
